import script from "./LimitedFactions.vue?vue&type=script&lang=ts&setup=true"
export * from "./LimitedFactions.vue?vue&type=script&lang=ts&setup=true"

import "./LimitedFactions.vue?vue&type=style&index=0&id=c9bd4cb6&lang=scss&scoped=true"

import exportComponent from "/home/deployment/actions-runner/_work/pwscorecards-vue/pwscorecards-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9bd4cb6"]])

export default __exports__